<div class="admin-page-wrap">
  <h1 class="page-title"><i class="bi bi-shield-exclamation me-2"></i> Fraud</h1>
  <p class="page-subtitle">
    Shared accounts, question-bank scraping, and robot-like request bursts.
    Caps live under Settings (<code>ANTIFRAUD_*</code> and <code>MAX_ACTIVE_USER_SESSIONS</code>).
  </p>

  @if (error) {
    <div class="alert alert-danger">{{ error }}</div>
  }

  @if (summary) {
    <div class="fraud-summary">
      <div class="panel stat-card">
        <div class="stat-card-content">
          <span class="stat-label">Open</span>
          <span class="stat-value">{{ summary.open }}</span>
        </div>
      </div>
      <div class="panel stat-card">
        <div class="stat-card-content">
          <span class="stat-label">Account sharing</span>
          <span class="stat-value">{{ summary.openAccountSharing }}</span>
        </div>
      </div>
      <div class="panel stat-card">
        <div class="stat-card-content">
          <span class="stat-label">Scraping</span>
          <span class="stat-value">{{ summary.openContentScrape }}</span>
        </div>
      </div>
      <div class="panel stat-card">
        <div class="stat-card-content">
          <span class="stat-label">Robot-like</span>
          <span class="stat-value">{{ summary.openRobotRequest }}</span>
        </div>
      </div>
    </div>
  }

  <div class="card">
    <div class="card-body">
      <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
        <label class="mb-0">Status
          <select class="form-select form-select-sm d-inline-block w-auto ms-1" [(ngModel)]="statusFilter" (ngModelChange)="onFilterChange()">
            <option value="">All</option>
            <option value="open">Open</option>
            <option value="resolved">Resolved</option>
            <option value="ignored">Ignored</option>
          </select>
        </label>
        <label class="mb-0">Signal
          <select class="form-select form-select-sm d-inline-block w-auto ms-1" [(ngModel)]="signalFilter" (ngModelChange)="onFilterChange()">
            <option value="">All</option>
            <option value="ACCOUNT_SHARING">Account sharing</option>
            <option value="CONTENT_SCRAPE">Content scraping</option>
            <option value="ROBOT_REQUEST">Robot-like requests</option>
          </select>
        </label>
      </div>

      @if (loading) {
        <p class="text-muted">Loading…</p>
      } @else if (events.length === 0) {
        <p class="text-muted mb-0">No incidents for this filter.</p>
      } @else {
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>When</th>
                <th>User</th>
                <th>Signal</th>
                <th>Severity</th>
                <th>Detail</th>
                <th>IP</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (event of events; track event.id) {
                <tr>
                  <td>{{ event.createdAt }}</td>
                  <td>
                    <a [routerLink]="['/admin/users']">{{ event.username || ('#' + event.userId) }}</a>
                  </td>
                  <td>{{ signalLabel(event.signal) }}</td>
                  <td>{{ event.severity }}</td>
                  <td class="fraud-detail">{{ event.detail }}</td>
                  <td>{{ event.ipAddress || '—' }}</td>
                  <td class="text-nowrap">
                    @if (event.status === 'open') {
                      <button type="button" class="btn btn-sm btn-outline-primary me-1"
                              [disabled]="updatingId === event.id"
                              (click)="setStatus(event, 'resolved')">Resolve</button>
                      <button type="button" class="btn btn-sm btn-outline-secondary"
                              [disabled]="updatingId === event.id"
                              (click)="setStatus(event, 'ignored')">Ignore</button>
                    } @else {
                      <button type="button" class="btn btn-sm btn-outline-secondary"
                              [disabled]="updatingId === event.id"
                              (click)="setStatus(event, 'open')">Reopen</button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (totalPages > 1) {
          <nav class="mt-3">
            <ul class="pagination mb-0">
              <li class="page-item" [class.disabled]="page === 0">
                <button type="button" class="page-link" (click)="page = page - 1; load()">Previous</button>
              </li>
              <li class="page-item disabled"><span class="page-link">{{ page + 1 }} / {{ totalPages }}</span></li>
              <li class="page-item" [class.disabled]="page + 1 >= totalPages">
                <button type="button" class="page-link" (click)="page = page + 1; load()">Next</button>
              </li>
            </ul>
          </nav>
        }
      }
    </div>
  </div>
</div>
